var map = {
	"./Alaska Roll psd 1.jpg": 4325,
	"./American Vibe psd 1.jpg": 3487,
	"./Avocado Maki psd 1.jpg": 7182,
	"./California Roll 1.jpg": 3715,
	"./California Salmon 1.jpg": 5557,
	"./Classic California Roll 1.jpg": 3355,
	"./Classic California Salmon 1.jpg": 4493,
	"./Crab Stick Roll psd 1.jpg": 8702,
	"./Futo Maki psd 1.jpg": 6049,
	"./Phil Avocado 1.jpg": 649,
	"./Phil Avocado psd 1.jpg": 2631,
	"./Philadelphia Green psd 1.jpg": 5160,
	"./Philadelphia Maki psd 1.jpg": 8508,
	"./Philadelphia Unagi psd 1.jpg": 9781,
	"./Salmon Roll psd 1.jpg": 8275,
	"./Salmon avocado Maki.jpg": 1405,
	"./Tomato Maki psd 1.jpg": 8256,
	"./Unagi Maki psd 1.jpg": 6658,
	"./Veggie Roll psd 1.jpg": 5031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6890;